<section class="px-lg md:px-6xl bg-white mb-lg md:mb-6xl xl:mb-7xl">
  <div class="mb-6xl">
    <h3 class="font-extrabold mb-md md:text-header text-large text-primary-500">
      {{ 'landing_page_why_join_contraa_section_title' | transloco }}
    </h3>
    <p class="text-neutral-700 text-small text-width">
      {{ 'landing_page_why_join_contraa_section_answer' | transloco }}
    </p>
  </div>

  <div class="why-join-container gap-3xl">
    <div class="cards gap-3xl">
      @for (reason of reasons; track reason.title) {
        <mars-landing-card
          cardClass="rtl:rtl"
          [iconComponent]="reason.iconComponent"
          [title]="reason.title | transloco"
          [description]="reason.description | transloco" />
      }
    </div>

    <div class="img-container flex justify-center bg-supplier-500 rounded-3xl">
      @defer (on viewport()) {
        <mars-why-join-contraa-animation />
      } @placeholder {
        <div>loading...</div>
      }
    </div>
  </div>
</section>
